<template>
  <b-modal v-model="showModal"
           @ok="submitReview"
           :ok-disabled="isAdding">
    <div slot="modal-title">
      {{ $t('message.my_reservations.review_cleaner') }}
    </div>
    <section>
      <div class="row" v-if="orderId">
        <div class="col-12">
          <div class="text-center">
            <div class="mb-2">
              <img v-lazy="professionalPicture" width="80" class="rounded-circle">
            </div>
            <div class="mb-2">
              {{ professionalName | firstName }}
            </div>
            <star-rating :rating="rating"
                         :inline="true"
                         :increment="1.0"
                         :show-rating="false"
                         @rating-selected="setRating"/>
          </div>

          <div class="mt-4 text-center" v-if="rating > 0">
            <h4>{{ ratingLevel }}</h4>
            <hr>
            <h4>{{ $t('message.because') }}</h4>
          </div>

          <div class="mt-4">
            <section v-if="rating >= 1 && rating < 4">
              <template v-for="topic in negativeTopics">
                <chips :topic="topic"/>
              </template>
            </section>

            <section v-else-if="rating >= 4 && rating <= 5">
              <template v-for="topic in positiveTopics">
                <chips :topic="topic"/>
              </template>
            </section>
          </div>

          <label class="mt-4">{{ $t('message.my_reservations.comment') }}</label>
          <textarea class="form-control" rows="4" v-model="comment"></textarea>
          <label class="mt-4">{{ $t('message.my_reservations.private_comment') }}</label>
          <textarea class="form-control" rows="4" v-model="privateComment"></textarea>
        </div>
      </div>
    </section>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="showModal = false">
        {{ $t('message.button.cancel') }}
      </b-button>
      <b-button variant="info"
                @click="ok()"
                :disabled="isAdding">
        {{ (isAdding) ? $t('message.button.loading') : $t('message.button.submit') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Chips from './Chips'
  import StarRating from 'vue-star-rating'

  export default {
    components: {
      Chips,
      StarRating
    },
    data () {
      return {
        orderId: null,
        professionalPicture: null,
        professionalName: null,
        showModal: false,
        rating: 0,
        comment: null,
        privateComment: null,
        selectedIndex: null,
        isAdding: false
      }
    },
    computed: {
      ...mapState('review', [
        'positiveTopics',
        'negativeTopics',
        'selectedPositiveTopics',
        'selectedNegativeTopics'
      ]),
      ratingLevel () {
        let levelText = ''
        switch (this.rating) {
          case 1:
            levelText = this.$i18n.t('message.rating.level01')
            break
          case 2:
            levelText = this.$i18n.t('message.rating.level02')
            break
          case 3:
            levelText = this.$i18n.t('message.rating.level03')
            break
          case 4:
            levelText = this.$i18n.t('message.rating.level04')
            break
          case 5:
            levelText = this.$i18n.t('message.rating.level05')
            break
        }
        return levelText
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      showReviewModal (status) {
        this.showModal = status
        if (status) {
          this.rating = 0
          this.comment = null
          this.privateComment = null
          this.$store.commit('review/SET_SELECTED_RATING_TOPICS', null)
        }
      },
      setOrderData (index, orderId, professionalId, professionalPicture, professionalName) {
        this.selectedIndex = index
        this.orderId = orderId
        this.professionalId = professionalId
        this.professionalPicture = professionalPicture
        this.professionalName = professionalName
      },
      setRating (rating) {
        this.rating = rating
      },
      async submitReview (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        this.isAdding = false
        if (this.rating < 1.0) {
          this.$swal({text: this.$i18n.t('message.alert.please_rate_cleaner'), type: 'error'})
        } else {
          this.isAdding = true
          // Rating topic ids
          const ratingTopicIds = (this.rating >= 1 && this.rating < 4) ? this.selectedNegativeTopics : this.selectedPositiveTopics
          const submitData = {
            order_id: this.orderId,
            professional_id: this.professionalId,
            rating: this.rating,
            comment: this.comment,
            private_comment: this.privateComment,
            rating_topic_ids: ratingTopicIds
          }
          await this.$store.dispatch('review/ADD_REVIEW', submitData)
          this.isAdding = false
          const data = {
            key: 'is_reviewed',
            value: true
          }
          if (this.selectedIndex > -1) {
            // Update reviewed order status for order list
            data.index = this.selectedIndex
            this.$store.commit('order/UPDATE_ORDER_DATA', data)
          } else {
            // Update reviewed order status for order detail
            this.$store.commit('orderDetail/UPDATE_ORDER_DETAIL_DATA', data)
          }
          this.showReviewModal(false)
          this.$swal({
            title: this.$i18n.t('message.success'),
            text: this.$i18n.t('message.my_reservations.report_issue_thank_you'),
            type: 'success'
          })
          this.$emit('onReviewedOrder', true)
          this.loadOrderDetail(this.orderId)
        }
      }
    },
    mounted () {
      this.$store.dispatch('review/LOAD_RATING_TOPICS')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReviewModal.vue